import React from 'react';
import { Tree, Spin } from 'antd';
import { connect } from 'dva';
import style from './index.less';

const { TreeNode, DirectoryTree } = Tree;

@connect(({ roleManagement }) => ({
  ...roleManagement,
}))
class TreeList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onSelect = this.onSelect.bind(this);
    this.onExpand = this.onExpand.bind(this);
  }

  onExpand = expandedKeys => {
    const { dispatch } = this.props;
    dispatch({
      type: 'roleManagement/save',
      payload: {
        expandedTreeNodeKeys: expandedKeys,
      },
    });
  };

  onSelect = (selectedKeys, info) => {
    const { dispatch } = this.props;
    const { treeNodeData } = info.node.props;
    dispatch({
      type: 'roleManagement/save',
      payload: {
        currentselectTreeNode: treeNodeData,
        isRoot: treeNodeData.isRoot,
        selectTreeNodeKey: selectedKeys,
      },
    });
    dispatch({
      type: 'roleManagement/fetchDeptRoleList',
      params: { deptId: treeNodeData.deptId, deptType: treeNodeData.deptType },
    });
  };

  treeListFun() {
    const { schoolTreeList, selectTreeNodeKey, expandedTreeNodeKeys, spinProps } = this.props;
    return (
      <Spin {...spinProps}>
        <DirectoryTree
          onExpand={this.onExpand}
          expandedKeys={expandedTreeNodeKeys}
          // autoExpandParent
          onSelect={this.onSelect}
          selectedKeys={selectTreeNodeKey}
        >
          {this.treeRecursionFun(schoolTreeList)}
        </DirectoryTree>
      </Spin>
    );
  }

  treeRecursionFun(data) {
    return (
      <TreeNode title={data.deptName} key={data.deptId} treeNodeData={data}>
        {(data.subDepts || []).map(items => {
          return this.treeRecursionFun(items);
        })}
      </TreeNode>
    );
  }

  render() {
    const { schoolTreeList } = this.props;
    return (
      <div className={style.treeList}>
        {schoolTreeList ? this.treeListFun() : <Spin tip="数据加载中..." />}
      </div>
    );
  }
}

export default TreeList;
